export default __webpack_public_path__ + "static/media/logo-300.85249726.png";